import { jsxs as i, jsx as o } from "react/jsx-runtime";
import { getModalPortal as d } from "../../../../../helpers/modal-helper.js";
import e from "./desktop-menu-modal.module.less.js";
import * as n from "@radix-ui/react-dialog";
import { VisuallyHidden as m } from "@radix-ui/react-visually-hidden";
const h = ({ children: r, isOpen: l, close: t, title: a }) => {
  const c = typeof t?.function == "function" ? t.function : void 0, s = d();
  return /* @__PURE__ */ i(n.Root, { open: l, modal: !1, children: [
    /* @__PURE__ */ o(n.Portal, { container: s, children: /* @__PURE__ */ o("div", { className: e.modalOverlay, onClick: t?.function }) }),
    /* @__PURE__ */ i(n.Content, { onEscapeKeyDown: c, className: [e.content].join(" "), children: [
      /* @__PURE__ */ o(m, { children: /* @__PURE__ */ o(n.Title, { children: a }) }),
      /* @__PURE__ */ o("div", { className: e.innerContent, children: r })
    ] })
  ] });
};
export {
  h as DesktopMenuModal,
  h as default
};
